import React from "react";
import LocalAtmIcon from "@mui/icons-material/LocalAtm";

function DashboardLoanDetails({ label, number, type, className }) {
  return (
    <div className="flex items-center gap-4 border border-black rounded-md p-4 px-6">
      <div className="p-2 bg-[#34A85326] rounded-md">
        <LocalAtmIcon sx={{ fontSize: "24px" }} />
      </div>
      <div className=" rounded-md ">
        <p className={` ${className} `}>{label}</p>
        <h3 className="font-semibold text-lg text-gray-800">
          {number}
          {type}
        </h3>
      </div>
      {/* <TrendingUpIcon sx={{ fontSize: "30px" }} /> */}
    </div>
  );
}

export default DashboardLoanDetails;
